export default __webpack_public_path__ + "static/media/user-avatar.8c3ca8b3.jpg";